import type { ReactNode } from 'react'
import { cn } from '@/shared/lib/utils'

/**
 * La columna de pasos de una sección del back-office.
 *
 * `show` existe por lo mismo que en `SubNavLink`: hay rutas que se dibujan SIN sus pasos —la
 * consola de la app del cliente le presta todo el ancho al teléfono (doc §5)— y envolver las
 * veinte entradas en un `&&` desde afuera esconde la condición veinte niveles arriba de lo que
 * gobierna. Se corta el árbol entero y no se esconde con CSS: la columna no tiene consultas
 * propias, pero sus entradas sí disparan validaciones al hacer clic.
 */
export const SubNav = ({
  title,
  show = true,
  children
}: {
  title?: string
  show?: boolean
  children?: ReactNode[] | ReactNode
}) => {
  if (!show) return null

  return (
    <div
      className={cn([
        'flex flex-col lg:min-w-[232px] lg:w-[232px] bg-accent/50 lg:h-full border-r border-muted z-10 pt-0 pb-0 lg:py-3 lg:pl-3 pr-0',
        'border-b-2 lg:border-b-0 border-b-muted'
      ])}
    >
      {title && (
        <div className="flex-col justify-between gap-4 w-full pb-0 pt-4 lg:py-4 px-0 lg:px-4 lg:h-[96px] hidden lg:flex">
          <span className="leading-tight pr-3 overflow-hidden text-primary text-xl font-semibold block lg:max-w-[12ch] px-4 lg:px-0">
            {title}
          </span>
          <hr className="border-muted-foreground/30" />
        </div>
      )}
      <div
        className={cn([
          'flex lg:flex-col lg:flex-1 lg:gap-3 overflow-y-hidden lg:overflow-y-auto w-full overflow-x-scroll lg:overflow-x-hidden scroll-sidebar scroll-none relative'
        ])}
      >
        {children}
      </div>
    </div>
  )
}
